module.exports = __webpack_public_path__ + "media/public/images/about/services/05-fac4e283a4846d2948491236a5f84c4f.jpg";